import { render, staticRenderFns } from "./CardRoomSize.vue?vue&type=template&id=44ef384e&scoped=true&"
import script from "./CardRoomSize.vue?vue&type=script&lang=ts&"
export * from "./CardRoomSize.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ef384e",
  null
  
)

export default component.exports